import { render, staticRenderFns } from "./ViewICD10.vue?vue&type=template&id=2f932002&scoped=true"
import script from "./ViewICD10.vue?vue&type=script&lang=js"
export * from "./ViewICD10.vue?vue&type=script&lang=js"
import style0 from "./ViewICD10.vue?vue&type=style&index=0&id=2f932002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f932002",
  null
  
)

export default component.exports